import React, {
  createContext,
  useContext,
  useMemo,
  useState,
} from "react";

const DashboardContext = createContext(null);

export function DashboardProvider({ children }) {
  const [selectedTab, setSelectedTab] = useState("Overview");   // admin/owner
  const [barberTab,   setBarberTab]   = useState("Overview");   // barber
  const [clientTab,   setClientTab]   = useState("Overview");   // client
  const [calendarDate, setCalendarDate] = useState(null);       // jump-to date for booking calendar
  const [barberColors, setBarberColors] = useState({});         // { user_id: colorObject } — set by calendar, read by overview
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false); // set by pages with dirty forms; side nav confirms before leaving

  const value = useMemo(
    () => ({
      selectedTab, setSelectedTab,
      barberTab,   setBarberTab,
      clientTab,   setClientTab,
      calendarDate, setCalendarDate,
      barberColors, setBarberColors,
      hasUnsavedChanges, setHasUnsavedChanges,
    }),
    [selectedTab, barberTab, clientTab, calendarDate, barberColors, hasUnsavedChanges]
  );

  return (
    <DashboardContext.Provider value={value}>
      {children}
    </DashboardContext.Provider>
  );
}

export function useDashContext() {
  const context = useContext(DashboardContext);
  if (!context) throw new Error("useDashContext must be used inside DashboardProvider");
  return context;
}
